import React from 'react';
import { SvgIcon } from '@mui/material';
import colors from '../../../../scss/colors';

function AiIcon({ light }) {
  return (
    <SvgIcon fontSize="inherit" viewBox="0 0 62 62" fill="none">
      <g id="DARK BLUE">
        <g id="SECTORS">
          <g id="DATA SCIENCE">
            <path
              id="Vector"
              d={`M32.0638 33.1708C33.1116 23.6809 36.8721 16.684 41.3339 16.684C45.2887 16.684 48.6858 22.2106 50.1477 
              30.0864M31.7934 36.7876C31.7934 37.4213 31.7934 38.0551 31.7934 38.7058C31.7934 50.866 36.0777 60.7276 
              41.3677 60.7276C46.6577 60.7276 50.9082 50.866 50.9082 38.7058C50.9082 37.0157 50.8237 35.4524 50.6801 
              33.9144M54.7701 36.7876C52.1404 34.3451 49.2366 32.2155 46.1168 30.4413C35.5876 24.3654 24.9063 23.1486 
              22.2613 27.7287C20.0473 31.5314 24.1711 38.2157 31.7596 43.8521M34.6243 45.8295C35.2496 46.2267 35.8918 
              46.6154 36.5425 46.9957C47.0802 53.08 57.7615 54.2968 60.3981 49.7167C61.9614 47.0126 60.3981 42.8972 
              56.6545 38.7312M37.4974 29.8751L36.5425 30.4413C26.0133 36.5256 19.6416 45.1704 22.2613 49.7505C24.5006 
              53.6293 32.5201 53.3419 41.3339 49.4632M45.1619 47.5703L46.1168 47.0295C56.6545 40.9452 63.0177 32.3088 
              60.3981 27.7287C58.1587 23.8415 50.1392 24.1288 41.3339 28.016M40.7677 13.4813V8.0223M40.7677 
              8.0223C40.7677 4.14356 31.8694 1 20.8839 1C9.8983 1 1 4.14356 1 8.0223M40.7677 8.0223C40.7677 11.9011 
              31.861 15.0362 20.8839 15.0362C9.90675 15.0362 1 11.9011 1 8.0223M1 8.0223V19.7177C1 23.25 8.40257 26.1823
               18.0361 26.6639M1 20.8923V31.4131C1 34.9538 8.40257 37.8777 18.0361 38.3678M1 32.5877V43.1169C1 46.6492 
               8.40257 49.5731 18.0361 50.0632M41.3339 35.8665C40.7656 35.8665 40.2101 36.035 39.7377 36.3507C39.2652 
               36.6664 38.8969 37.1151 38.6794 37.6401C38.462 38.1651 38.4051 38.7428 38.5159 39.3001C38.6268 39.8575 
               38.9005 40.3694 39.3023 40.7712C39.7041 41.173 40.216 41.4467 40.7734 41.5575C41.3307 41.6684 41.9084 
               41.6115 42.4334 41.394C42.9584 41.1766 43.4071 40.8083 43.7228 40.3358C44.0385 39.8634 44.207 39.3079 
               44.207 38.7396C44.2115 38.3595 44.1405 37.9822 43.9981 37.6297C43.8557 37.2772 43.6448 36.9565 43.3776 
               36.6861C43.1103 36.4157 42.7921 36.201 42.4413 36.0546C42.0904 35.9081 41.7141 35.8326 41.3339 
               35.8327V35.8665Z`}
              stroke={light ? 'url(#paint0_linear_10146_175857)' : colors.WHITE}
              strokeWidth="1.96"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_10146_175857"
          x1="31"
          y1="1"
          x2="31"
          y2="60.7276"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#073F59" />
          <stop offset="1" stopColor="#1792CE" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
}

export default AiIcon;
